// 全屏-地图
<template>
  <div class="DkbFMap">
    地图内容
  </div>
</template>

<script>
  import { localUserInfo, showToast } from "../../../../static/js/utility/utility.js"
  let vm

  export default {
    name: 'DkbFMap',
    components: {
    },
    data () {
      return {
      }
    },
    created () {
      vm = this
   
    },
    mounted() {
      // console.log('route', this.$route)
    },
    computed: {
    },
    methods: {
    },
    watch: {
    }
  }
</script>

<style lang="scss" scoped>
.DkbFMap {

}
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/FScreen/Map.vue